export enum PingOrder {
    REQUEST = 'PING_ORDER_REQUEST',
    SUCCESS = 'PING_ORDER_SUCCESS',
    FAILURE = 'PING_ORDER_FAILURE',
    RESET = 'PING_ORDER_RESET'
}

export enum AttemptPayment {
    REQUEST = 'ATTEMPT_PAYMENT_REQUEST',
    SUCCESS = 'ATTEMPT_PAYMENT_SUCCESS',
    FAILURE = 'ATTEMPT_PAYMENT_FAILURE'
}

export enum PaymentMethodTypes {
    SET = 'SET_PAYMENT_METHOD',
    RESET = 'RESET_PAYMENT_METHOD'
}

export const SET_ORDER_WORKFLOW_PAGE = 'SET_ORDER_WORKFLOW_PAGE';

// export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
// export const RESET_PAYMENT_METHOD = 'RESET_PAYMENT_METHOD';

// export const ATTEMPT_PAYMENT_REQUEST = 'ATTEMPT_PAYMENT_REQUEST';
// export const ATTEMPT_PAYMENT_SUCCESS = 'ATTEMPT_PAYMENT_SUCCESS';
// export const ATTEMPT_PAYMENT_FAILURE = 'ATTEMPT_PAYMENT_FAILURE';

// export const PING_ORDER_REQUEST = 'PING_ORDER_REQUEST';
// export const PING_ORDER_SUCCESS = 'PING_ORDER_SUCCESS';
// export const PING_ORDER_FAILURE = 'PING_ORDER_FAILURE';
// export const PING_ORDER_RESET = 'PING_ORDER_RESET';

// export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
// export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
// export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';
